import { Col, Container, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import $appSettings from 'signals/AppSettings.signal';
import currencyOptions from 'components/global/Constant/currencyOptions';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {
  fetchAndSetSediPerformanceData,
  getLastTwelveMonths,
} from './EdoSedi.helpers';
import edoSediSignal from './EdoSedi.signals';
import { checkEdoPermissionsAcrossPrograms } from '../../../../libs/edoPermissions';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import api from '../../../../api/api';
import loaderSignal from '../../../../signals/Loader.signal';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: 'SEDI Target and Performance',
    },
  },
};

const labels = getLastTwelveMonths();
export const dataBuilder = () => ({
  labels,
  datasets: [
    {
      label: 'SEDI Target',
      data: labels.map(
        () =>
          ($appSettings.value.appSettings.sediObjectives *
            $appSettings.value.appSettings.initialEligibleAmounts) /
          100
      ),
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    },
    {
      label: 'Expended',
      data: labels.map((month, index) => {
        const expendedRecords = edoSediSignal.value.expended;
        console.log('expendedRecords', expendedRecords);
        return (index + 6) * (index + 9) * 10000;
      }),
      borderColor: 'rgb(53, 162, 235)',
      backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
    {
      label: 'Obligated',
      data: labels.map((month, index) => {
        const obligatedRecords = edoSediSignal.value.obligated;
        console.log('obligatedRecords', obligatedRecords);
        return (index + 12) * (index + 15) * 10000;
        // return obligatedRecords[month];
      }),
      borderColor: 'rgb(235, 162, 54)',
      backgroundColor: 'rgba(235, 162, 54, 0.5)',
    },
  ],
});

const EdoSedi = () => {
  const appSettings = $appSettings.value.appSettings;
  const [canView, setCanView] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Check if user has canView permission on any program
  useEffect(() => {
    const checkViewPermission = async () => {
      try {
        setIsChecking(true);
        loaderSignal.update({ isContentLoading: true });
        const userData = userAccountSignal.value.userData;
        
        // Wait for userData to be loaded
        if (!userData) {
          setIsChecking(false);
          loaderSignal.reset();
          return;
        }

        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userData?.account.edoId,
            },
          },
        });

        const permissions = await checkEdoPermissionsAcrossPrograms(
          fundingPrograms,
          ['canView']
        );
        setCanView(permissions.canView);
      } catch (error) {
        console.error('Error checking view permission:', error);
        setCanView(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkViewPermission();
  }, [userAccountSignal.value.userData]);

  useEffect(() => {
    if (canView) {
      fetchAndSetSediPerformanceData();
    }
  }, [canView]);

  if (isChecking) {
    return (
      <Container fluid className="mb-32">
        <div className="bg-white px-32 py-24 border border-gray shadow-sm">
          <p className="text-center">Loading...</p>
        </div>
      </Container>
    );
  }

  if (!canView) {
    return (
      <Container fluid className="mb-32">
        <div className="bg-white px-32 py-24 border border-gray shadow-sm">
          <h3 className="text-center">Access Denied</h3>
          <p className="text-center">
            You do not have permission to view SEDI data.
          </p>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="mb-32">
      <div className="bg-white px-32 py-24 border border-gray shadow-sm">
        <h3 className="text-center">SEDI Target and Performance</h3>
        <hr />
        <Row>
          <Col>
            <p>
              <b>Initial Eligible Amounts:</b>{' '}
              {appSettings.initialEligibleAmounts.toLocaleString(
                'en-US',
                currencyOptions.currencyUSNoDecimal
              )}
            </p>
          </Col>
          <Col>
            <p>
              <b>SEDI Target:</b> {appSettings.sediObjectives}%
            </p>
          </Col>
          <Col>
            <p>
              <b>Target Amount: </b>{' '}
              {(
                (appSettings.sediObjectives / 100) *
                appSettings.initialEligibleAmounts
              ).toLocaleString('en-US', currencyOptions.currencyUSNoDecimal)}
            </p>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Line options={options} data={dataBuilder()} />
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default EdoSedi;
